
export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-[#162840] to-[#1A2F4F] text-white py-6">
      <div className="max-w-6xl mx-auto px-6 py-6">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="https://public.readdy.ai/ai/img_res/977ae90f-2461-4819-91c5-15a96a5cdd46.png" 
              alt="BitFlow Solutions" 
              className="h-10 w-auto"
            />
          </div>

          <div className="flex flex-col md:flex-row items-center gap-4 md:gap-6 text-sm">
            <p className="text-white/60">
              © 2025 BitFlow Solutions. Todos os direitos reservados.
            </p>
            <span className="hidden md:inline text-white/30">|</span>
            <p className="text-white/50">CNPJ: 50.684.143/0001-38</p>
          </div>

          <div className="flex items-center space-x-4 text-sm">
            <a href="#" className="text-white/60 hover:text-[#72BF3B] transition-colors cursor-pointer">Privacidade</a>
            <a href="#" className="text-white/60 hover:text-[#72BF3B] transition-colors cursor-pointer">Termos</a>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-[#72BF3B] transition-colors cursor-pointer">Powered by Readdy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
